module.exports = __webpack_public_path__ + "img/alert2.png";